import Cookies from "cookies-js";

class portalUser {
    constructor() {
        this.cookieName = "MaJgJWUVjuZt8KT882TQ2Q5zYp8d94VrpMn3ukQTJwAAb9VEx";
    }

    isValid() {
        return Cookies.get(this.cookieName) !== undefined;
    }

    get token() {
        return Cookies.get(this.cookieName);
    }

    setToken(token) {
        Cookies.set(this.cookieName, token);
    }

    logout() {
        Cookies.expire(this.cookieName);
    }
}

export let PortalUser = new portalUser();
